import axios from "axios";
import configuration from "@/utils/configuration";
import { enums } from "@/utils/enums";
import Vue from "vue";
import { handleError } from "@/utils/errorHandler";

const attendanceModules = {
    namespaced: true,
    state: {
        attendanceList: [],
        attendanceDetail: {},
        saveCheckInStudent: {},
        error: {},
        loadingAttendance: false
    },
    mutations: {
        SET_ATTENDANCE_LISTS(state, attendanceList) {
            state.attendanceList = attendanceList
        },
        SET_ATTENDANCE_DETAILS(state, attendanceDetail) {
            state.attendanceDetail = attendanceDetail;
        },
        SET_CHECKIN_STUDENTS(state, saveCheckInStudent) {
            state.saveCheckInStudent = saveCheckInStudent;
        },
        SET_ERROR(state, { action, message }) {
            Vue.set(state.error, action, message);
        },
        SET_LOADING(state, loadingAttendance) {
            state.loadingAttendance = loadingAttendance;

        },

    },
    actions: {
        async getAttendanceLists({ commit },params) {
            commit("SET_LOADING", true);
            try {
                const { data } = await axios({
                    method: "GET",
                    url: `${configuration.backUrl}/checkin/coach`,
                    params: params,
                    withCredentials: true,
                });
                commit("SET_ATTENDANCE_LISTS", data.data.attendanceList);
                return data.data
            } catch (error) {
                commit("SET_ATTENDANCE_LISTS", []);
                throw error;
            } finally {
                commit("SET_LOADING", false);
            }
        },
        async getAttendanceDetails({ commit }, { courseId, date, startTime, endTime, coachId }) {
            commit("SET_LOADING", true);
            try {
                const { data } = await axios({
                    method: "GET",
                    url: `${configuration.backUrl}/checkin/student`,
                    params: {
                        course_id: courseId,
                        date: date,
                        start_time: startTime,
                        end_time: endTime,
                        coach_id: coachId,
                    },
                    withCredentials: true,
                });
                for (const items of data.data?.students) {
                    items.selectedStatus = items?.checkinStatus ? items?.checkinStatus : enums.CHECKINSTATUS.PUNCTUAL
                    items.specialStatus = null,
                        items.postponedDate = items?.newDate ? items?.newDate : null,
                        items.postponedStartTime = items?.newStartTime ? items?.newStartTime : null,
                        items.postponedEndTime = items?.newEndTime ? items?.newEndTime : null,
                        items.postponedDatePicker = false
                    items.isPostponedSaved = items.selectedStatus !== null ? true : false
                }
                commit("SET_ATTENDANCE_DETAILS", data.data);
                return data.data
            } catch (error) {
                commit("SET_ATTENDANCE_DETAILS", []);
                throw error;
            } finally {
                commit("SET_LOADING", false);
            }
        },

        async postCheckIn({ commit }, payload) {
            const action = "postAdminCheckIn";
            commit('SET_ERROR', { action, message: null });
            commit("SET_LOADING", true);


            try {
                const { data } = await axios({
                    method: "POST",
                    url: `${configuration.backUrl}/checkin/coach-checkin-later`,
                    data: payload,
                    withCredentials: true,
                });
                return data.data
            } catch (error) {
                handleError(commit, action, error);
            } finally {
                commit("SET_LOADING", false);
            }
        },
        async saveCheckInStudents({ commit }, payload) {
            const action = "saveCheckInStudents";
            commit("SET_LOADING", true);
            commit('SET_ERROR', { action, message: null });
            try {
                const { data } = await axios({
                    method: "POST",
                    url: `${configuration.backUrl}/checkin/student-checkin-later`,
                    data: payload,
                    withCredentials: true,
                });
                commit("SET_CHECKIN_STUDENTS", data.success);
                return data.data
            } catch (error) {
                handleError(commit, action, error);
            } finally {
                commit("SET_LOADING", false);
            }
        }

    },
    getters: {
        attendanceList: (state) => state.attendanceList,
        attendanceDetail: (state) => state.attendanceDetail,
        saveCheckInStudent: (state) => state.saveCheckInStudent,
        loadingAttendance: (state) => state.loadingAttendance,
        getError: (state) => (action) => state.error[action],


    }

}
export default attendanceModules;
